import { APIRequest, Service } from '../../../../../root.types';

export const fetchServices = (request: APIRequest) => async () => {
  return request<Service[]>({
    method: 'get',
    path: '/services',
  });
};
